export default __webpack_public_path__ + "img/partnership3-b7eedfe2e3e14ee93d9dbbfd30c3d966.png";